import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import FooterButton from '../../components/FooterButton'
import MyWishlistItems from '../../components/MyWishlistItems'
import Spinner from '../../components/Spinner'
import ModalMessage from '../../components/ModalMessage'

import { ReactComponent as PlusSvg } from '../../assets/plus.svg'

import MaisConteudoAPi from '../../services/MaisConteudoAPi'

import { FooterButtonNameCreateWishList } from '../Products/styles'
import { Container, WishlistContent } from './styles'
import { SeparateLineTop } from '../../utils/style'
import { storedEnv } from '../../utils/localStorage'
import WarningCard from '../../components/WarningCard'


interface IWishlistsState {
    name: string;
    products: {
        price: number

    }[];
    environment: string;
    linkId: string;
    createdAt: string;
}

interface IErrorState {
    error: string;
    isToShow: boolean;
}

const MyWishlists: React.FC = () => {

    const mounted = useRef(false)
    const isFarm = storedEnv === 'lojafarm';

    const [wishlists, setWishlists] = useState<IWishlistsState[]>([])

    const [loading, setLoading] = useState<boolean>(true)
    const [isEmpty, setIsEmpty] = useState<boolean>(false)
    const [error, setError] = useState<IErrorState>({ error: '', isToShow: false })

    const footerButtonNameMemo = useMemo(() => (
        <FooterButtonNameCreateWishList>
            <PlusSvg />
            <span>Criar lojinha</span>
        </FooterButtonNameCreateWishList>
    ), [])

    const onCloseModalErrorHandler = useCallback(() => setError(prevState => ({ ...prevState, isToShow: false })), [])

    const userWishlist = useCallback(async () => {
        setLoading(true)
        try {
            const res = await MaisConteudoAPi.get(`/v1/wishlists/user`)
            if (mounted.current) {
                setLoading(false)
                if (res.data.filter((wishlist: { environment: string }) => wishlist.environment === storedEnv).length === 0) {
                    setIsEmpty(true)
                }
                setWishlists(res.data.filter((wishlist: { environment: string }) => wishlist.environment === storedEnv))
            }
        } catch (error: any) {
            setError({
                error: error.response?.data.message || "Algo de errado aconteceu, por favor tente novamente!",
                isToShow: true
            })
        }
        setLoading(false)
    }, [])

    useEffect(() => {
        mounted.current = true

        userWishlist()

        return () => { mounted.current = false }
    }, [userWishlist])

    return (
        <Container className='wishlists'>

            <ModalMessage
                isOpen={error.isToShow}
                onClose={onCloseModalErrorHandler}
                optionSVG="errorImage"
                textWishList={error.error}
                tittle="Oops..."
            />
            
            {
                isFarm && 
                <WarningCard className=''>
                    Aviso: Lojinhas criadas antes de 01/01/2024 só terão informações de vendas disponíveis a partir dessa data.            
                </WarningCard>
            }

            {
                loading ? <Spinner /> : (
                    
                    <WishlistContent>
                        <SeparateLineTop />
                        <MyWishlistItems loading={loading} isEmpty={isEmpty} wishlists={wishlists} />
                    </WishlistContent>
                )
            }

            <FooterButton
                name={footerButtonNameMemo}
                disabled={false}
                onClick={() => null}
                to='/create-wishlist'
            />
        </Container>
    )
}

export default MyWishlists